import "./App.css";
import HeaderComponent from "./components/header";
import HelperComponent from "./components/helper";
import AppRoutes from "./routes/AppRoutes";
import { BrowserRouter, useNavigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { useAuth } from "./context/AuthContext";
import { useEffect } from "react";

function AppContent() {
  const navigate = useNavigate();
  const { breadcrumbs, setBreadcrumbs } = useAuth();
  const handleClick = (id, title, path) => {
    const existingIndex = breadcrumbs.findIndex((b) => b.path === path);
    let updated;
    if (existingIndex !== -1) {
      updated = breadcrumbs.slice(0, existingIndex + 1);
    } else {
      updated = [...breadcrumbs, { id, title, path }];
    }
    setBreadcrumbs(updated);
    navigate(path);
  };
  const { auth } = useAuth();
  useEffect(() => {
    // console.log("Auth in AppContent:", auth);
    if (!auth?.token) navigate("/login");
  }, [auth, navigate]);
  return <AppRoutes handleClick={handleClick} />;
}

function LayoutWrapper({ children }) {
  const navigate = useNavigate();
  const { breadcrumbs, setBreadcrumbs } = useAuth();

  const handleClick = (id, title, path) => {
    const existingIndex = breadcrumbs.findIndex((b) => b.path === path);
    let updated;
    if (existingIndex !== -1) {
      updated = breadcrumbs.slice(0, existingIndex + 1);
    } else {
      updated = [...breadcrumbs, { id, title, path }];
    }
    setBreadcrumbs(updated);
    navigate(path);
  };
  const location = useLocation();

  const hideLayoutRoutes = ["/login"];

  const shouldHideLayout = hideLayoutRoutes.includes(location.pathname);

  return (
    <>
      {!shouldHideLayout && <HeaderComponent handleClick={handleClick} />}
      {!shouldHideLayout && <HelperComponent />}
      {children}
    </>
  );
}

function App() {
  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link
        href="https://fonts.googleapis.com/css2?family=Afacad:ital,wght@0,400..700;1,400..700&family=Archivo+Black&family=Averia+Gruesa+Libre&family=Bakbak+One&family=Baloo+Bhai+2:wght@400..800&family=Candal&family=Lateef:wght@200;300;400;500;600;700;800&family=Aoboshi+One&family=Alata&family=Source+Code+Pro:wght@400;500;600;700&family=Fredoka:wght@300..700&display=swap"
        rel="stylesheet"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Luckiest+Guy&display=swap"
        rel="stylesheet"
      />



      <BrowserRouter>
        <AuthProvider>
          <LayoutWrapper>
            <AppContent />
          </LayoutWrapper>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
